import React from "react";
import TransactionTable from "../components/TransactionTable";

function Transactions() {
  return (
    <main className="flex-1">
      <div className="py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
          {/* Replace with your content */}
          <TransactionTable />
          {/* /End replace */}
        </div>
      </div>
    </main>
  );
}

export default Transactions;
